<template>
    <div class="footer">
        <div class="footer__inner">
            <div class="footer__main">
                <div class="footer__col">
                    <img src="../images/banner-logo.svg" class="footer__logo">
                    <div class="footer__social contacts">
                        <a class="contacts__link contacts__link_vk" href="https://vk.com/kudrovoflowersspb24"></a>
                        <a class="contacts__link contacts__link_wa" href="https://api.whatsapp.com/send?phone=79218077750"></a>
                        <a class="contacts__link contacts__link_tg" href="https://t.me/+79218077750"></a>
                    </div>
                </div>

                <div class="footer__col">
                    <h2 class="footer__heading">Заказать</h2>
                    <button 
                        type="button" 
                        @click="selectCategory('До 4000₽')"
                        class="footer__btn">Букеты до 4000</button>

                    <button 
                        type="button" 
                        @click="selectCategory('От 4000₽')"
                        class="footer__btn">Букеты от 4000</button>

                    <button 
                        type="button" 
                        @click="selectCategory('от 6000₽')"
                        class="footer__btn">Премиум</button>
                </div>

                <div class="footer__col">
                    <h2 class="footer__heading">Контакты</h2>
                    <a href="tel:+79218077750" class="footer__item">+7(921)807-77-50*</a>
                    <p class="footer__item footer__col-contacts">*По вопросам наличия или заказа в конкретном магазине, обращайтесь по номеру из раздела <router-link class="footer__item_link" to="/contacts">контакты</router-link></p>
                    <a href="mailto:Lenbuket24@yandex.ru" class="footer__item">Lenbuket24@yandex.ru</a>
                    <div class="footer__social footer__social_mob contacts">
                        <a class="contacts__link contacts__link_vk" href="https://vk.com/kudrovoflowersspb24"></a>
                        <a class="contacts__link contacts__link_wa" href="https://api.whatsapp.com/send?phone=79218077750"></a>
                        <a class="contacts__link contacts__link_tg" href="https://t.me/+79218077750"></a>
                    </div>
                </div>

                <div class="footer__col">
                    <h2 class="footer__heading">ленбукет</h2>
                    <router-link to="/contacts" class="footer__item">Контакты</router-link>
                    <router-link to="/delivery" class="footer__item">Доставка и оплата</router-link>
                    <router-link to="/catalog" class="footer__item">Каталог</router-link>
                </div>

                <div class="footer__col">
                    <h2 class="footer__heading">Поиск по сайту</h2>
                    <div class="footer__search search">
                    <input 
                        placeholder="Какой букет Вас интересует?" 
                        class="search__field" 
                        @keyup.enter="search"
                        v-model="searchValue">
                    <button
                        type="button" 
                        @click="search" 
                        class="search__button"></button>
                </div>
                </div>
            </div>

            <div class="footer__bottom footer-legal">
                <p class="footer-legal__item">ИП Думич Александра Сергеевна</p>
                <p class="footer-legal__item">Юридический адрес:</p>
                <p class="footer-legal__item">Россия, г. Санкт-Петербург, , ул. Плесецкая, д. 6, стр.1, кв.178</p>
                <p class="footer-legal__item">ИНН 781424466647 / ОРГН/ОГРНИП 321784700156325</p>
                <router-link to="/confidential" class="footer-legal__link">Политика конфиденциальности</router-link>
                <router-link to="/oferta" class="footer-legal__link">Оферта</router-link>
                <p class="footer-legal__creator">Сайт разработан <a href="https://vsegda-digital.ru/" class="footer-legal__creator-link">Vsegda</a></p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            searchValue: ''
        }
    },
    methods: {
        ...mapActions([
            'GET_SEARCH_VALUE',
            'RESET_PAGE_NUMBER',
            'GET_CATEGORY_VALUE',
            'RESET_CATEGORY',
            'GET_PRODUCTS',
            'SELECT_CATEGORY',
            'RESET_SEARCH_VALUE'

        ]),
        search(){
            this.GET_SEARCH_VALUE(this.searchValue)
            this.RESET_PAGE_NUMBER()
            this.GET_CATEGORY_VALUE('')
            this.RESET_CATEGORY()
            this.GET_PRODUCTS()
            this.$router.push('/catalog')
        },
        selectCategory(category){
            this.GET_CATEGORY_VALUE('')
            this.SELECT_CATEGORY(category);
            this.RESET_PAGE_NUMBER();
            this.RESET_SEARCH_VALUE();
            this.GET_PRODUCTS();
            this.$router.push('/catalog')
        }
    },
}
</script>

<style scoped>
    .footer__main{
        display: flex;
        justify-content: space-between;
        margin-bottom: 70px;
    }
    .footer__col{
        display: flex;
        flex-direction: column;
        margin-right: 20px;
    }
    .footer__col:last-child{
        margin-right: 0;
    }
    .footer__logo{
        max-width: 183px;
        margin-bottom: 30px;
    }
    .footer__social{
        max-width: 183px;
        display: flex;
        justify-content: space-between;
    }
    .contacts__link{
        height: 40px;
        width: 40px;
        border-radius: 50%;
        transition: all linear .2s;
    }
    .contacts__link:hover{
        opacity: .5;
    }
    .contacts__link_vk{
        background: url(../images/icons/vk-ico.svg) no-repeat;
        background-size: cover;
    }
    .contacts__link_wa{
        background: url(../images/icons/wa-ico.svg) no-repeat;
        background-size: cover;
        border-radius: 0;
    }
    .contacts__link_tg{
        background: url(../images/icons/tg-ico.svg) no-repeat;
        background-size: cover;
        margin-right: 0;
    }
    .footer__search{
        display: flex;
        margin-left: auto;
        width: 100%;
        max-width: 320px;
        border-radius: 47px;
        border: 1px solid #ECDED3;
        transition: all linear .2s;
        margin-right: 90px;
    }
    .header__search:hover{
        border-color: #000;
    }
    .search__field{
        border: none;
        padding: 12px 20px;
        width: 100%;
        height: 100%;
        transition: all linear .1s;
        background-color: transparent;
        font-family: 'Romul';
        font-size: 12px;
    }
    .search__field:focus{
        outline: none;
    }
    .search__button{
        background: none;
        border: none;
        width: 50px;
        background: url(../images/icons/search-ico.svg) no-repeat;
        background-position: center;
        transition: all linear .2s;
    }
    .search__button:hover{
        opacity: .5;
    }
    .footer__heading{
        font-size: 24px;
        color: #514E47;
        margin-bottom: 10px;
        font-weight: 400;
        font-family: 'Romul';
    }
    .footer__item{
        font-size: 20px;
        margin-bottom: 20px;
        color: #514E47;
    }
    .footer__item:hover{
        text-decoration: underline;
    }
    .footer__btn{
        font-size: 20px;
        margin-bottom: 20px;
        font-family: "Bona Nova", serif;
        text-align: start;
        color: #514E47;
    }
    .footer__btn:hover{
        text-decoration: underline;
    }
    .footer__item:last-child{
        margin-bottom: 0;
    }
    .footer__bottom{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .footer-legal__item{
        font-size: 14px;
        margin-bottom: 10px;
    }
    .footer-legal__link{
        font-size: 14px;
        margin-bottom: 10px;
    }
    .footer-legal__link:hover{
        text-decoration: underline;
    }
    .footer-legal__creator{
        font-size: 14px;
    }
    .footer-legal__creator-link{
        font-size: 14px;
        text-decoration: underline;
    }
    .footer__social_mob{
        display: none;
    }
    .footer__col-contacts{
        font-size: 14px;
        max-width: 250px;
    }
    .footer__col-contacts:hover{
        text-decoration: none;
    }
    .footer__item_link{
        text-decoration: underline;
    }
    .footer__item_link:hover{
        text-decoration: none;
    }
    @media (max-width: 992px) {
        .footer__main{
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 25px;
        }
        .footer__heading{
            font-size: 20px;
        }
    }
    @media (max-width: 600px){
        .footer__social{
            display: none;
        }
        .footer__social_mob{
            display: flex;
            max-width: 135px;
        }
        .footer-legal__link{
            text-decoration: underline;
        }
        .contacts__link{
            width: 36px;
            height: 36px;
        }
        .footer__main{
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 40px 5px;
        }
        .footer__col:last-child{
            order: -1;
            grid-column: span 2;
            margin-bottom: 10px;
        }
        .footer__col:first-child{
            order: 4;
            margin-right: 0;
            align-items: flex-end;
        }
        .footer__col:nth-child(2){
            order: 1;
        }
        .footer__col:nth-child(3){
            order: 3;
            text-align: start;
        }
        .footer__col:nth-child(3) .footer__btn{
            text-align: end;
        }
        .footer__col:nth-child(4){
            order: 2;
        }
        .footer__col:nth-child(4) .footer__btn{
            text-align: end;
        }
        .footer__search{
            max-width: none;
            margin-left: 0;
            margin-right: 0;
        }
        .footer__btn,
        .footer__item{
            font-size: 16px;
        }
        .footer__logo{
            max-width: 160px;
        }
        .footer__main{
            margin-bottom: 50px;
        }
        .footer-legal__item{
            text-align: center;
        }
    }
</style>